import NonEssentialNeedsCalculator from "./NonEssentialNeedsCalculator"

export default NonEssentialNeedsCalculator